function Trainers() {
    return (
      <section className="section">
        <h2>Trainers</h2>
  
        <div className="grid">
          <div className="card">Rahul - Strength</div>
          <div className="card">Neha - Yoga</div>
          <div className="card">Amit - Cardio</div>
        </div>
      </section>
    );
  }
  
  export default Trainers;